<template>
    <div id="app" class="wn-conf">
        <div id="configurator" class="container configurator c-bg">
            <div class="columns is-gapless is-reverse">
                <!-- VISUAL START -->
                <div class="configurator__column configurator__column--visual column">
                    <div class="configurator__visual">
                        <!--img class="configurator__layer configurator__layer--logo" src="/modules/custom/wn_conf/assets/img/wassernator-white-w.svg" alt="" /-->
                        <div class="configurator__layerwrapper">
                            <div
                                v-if="stepIsCurrent('loading') || stepIsCurrent('calc') || assembly.tank === undefined"
                                class="configurator__layer configurator__layer--logo"
                            >
                                <img
                                    src="/modules/custom/wn_conf/assets/img/wassernator-white-w.svg"
                                    alt
                                />
                            </div>
                            <!-- Tank as 1st level -->
                            <div v-if="stepInPath('tank') || stepInPath('cover')" class="configurator__layer configurator__layer--base">
                                <img v-if="assembly.tank != undefined && assembly.tank.images != undefined && assembly.tank.images.layer != undefined"
                                    v-bind:src="assembly.tank.images.layer"
                                    v-bind:alt="assembly.tank.name"
                                />
                                <!--img src="/modules/custom/wn_conf/assets/products/tank-2200.png" alt="" /-->
                            </div>
                            
                            <!-- Tank-Section Overlay as 2nd level -->
                            <div
                                v-if="stepInPath('filter') && assembly.tank.images != undefined"
                                class="configurator__layer"
                            >
                                <img
                                    v-bind:src="assembly.tank.images.section"
                                    v-bind:alt="assembly.tank.name"
                                />
                            </div>
                            <!-- then all the other Items -->

                            <!-- COVER -->
                            <div v-if="stepInPath('cover') && getComponentImage(this.assembly.cover)" class="configurator__layer">
                                <img
                                    v-bind:src="getComponentImage(this.assembly.cover)"
                                    v-bind:alt="assembly.cover.name"
                                />
                            </div>

                            <!-- FILTER -->
                            <div v-if="stepInPath('filter') && getComponentImage(this.assembly.filter)" class="configurator__layer">
                                <img
                                    v-bind:src="getComponentImage(this.assembly.filter)"
                                    v-bind:alt="assembly.cover.name"
                                />
                            </div>
                        
                            <!-- EXTRACTION -->
                            <div v-if="stepInPath('extraction') && getComponentImage(this.assembly.extraction)" class="configurator__layer">
                                <img
                                    v-bind:src="getComponentImage(this.assembly.extraction)"
                                    v-bind:alt="assembly.cover.name"
                                />
                            </div>

                            <!-- Hotspot TANK -->
                            <span
                                v-if="stepInPath('tank') && assembly.tank != undefined && assembly.tank.position != undefined"
                                v-bind:style="{ top: assembly.tank.position.y + '%', left: assembly.tank.position.x + '%' }"
                                class="configurator__layer configurator__hotspot icon is-large has-text-white"
                            >
                                <i
                                    class="fas fa-2x fa-plus-circle"
                                    @click="showProductModal(assembly.tank.id)"
                                ></i>
                            </span>

                            <!-- Hotspot COVER -->
                            <span
                                v-if="stepInPath('cover') && assembly.cover != undefined && assembly.cover.position != undefined"
                                v-bind:style="{ top: assembly.cover.position.y + '%', left: assembly.cover.position.x + '%' }"
                                class="configurator__layer configurator__hotspot icon is-large has-text-white"
                            >
                                <i
                                    class="fas fa-2x fa-plus-circle"
                                    @click="showProductModal(assembly.cover.id)"
                                ></i>
                            </span>

                            <!-- Hotspot FILTER -->
                            <span
                                v-if="stepInPath('filter') && assembly.filter != undefined && assembly.filter.position != undefined"
                                v-bind:style="{ top: assembly.filter.position.y + '%', left: assembly.filter.position.x + '%' }"
                                class="configurator__layer configurator__hotspot icon is-large has-text-white"
                            >
                                <i
                                    class="fas fa-2x fa-plus-circle"
                                    @click="showProductModal(assembly.filter.id)"
                                ></i>
                            </span>

                            <!-- Hotspot EXTRACTION -->
                            <span
                                v-if="stepInPath('extraction') && assembly.extraction != undefined && assembly.extraction.position != undefined"
                                v-bind:style="{ top: assembly.extraction.position.y + '%', left: assembly.extraction.position.x + '%' }"
                                class="configurator__layer configurator__hotspot icon is-large has-text-white"
                            >
                                <i
                                    class="fas fa-2x fa-plus-circle"
                                    @click="showProductModal(assembly.extraction.id)"
                                ></i>
                            </span>

                            <!-- WATERDROP (Volume) -->
                            <div v-if="stepInPath('tank') && assembly.tank != undefined" class="configurator__waterdrop">
                                <div class="configurator__capacity">
                                    <strong>{{ assembly.tank.capacity }}</strong>
                                    <br />Liter
                                </div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="102"
                                    viewBox="0 0 102 144"
                                    fill="none"
                                >
                                    <path
                                        fill="#071439"
                                        d="M50.4332 1c94.3378 89.4053 34.0665 141.558 0 141.558s-91.7175-52.1527 0-141.558z"
                                    />

                                    <!--path fill="#009EE2" d="M50.4332 1c94.3378 89.4053 34.0665 141.558 0 141.558s-91.7175-52.1527 0-141.558z"/-->
                                </svg>
                            </div>

                            <!-- SUMM -->
                            <div class="configurator__summdisplay" v-if="assembly.tank != undefined && (stepInPath('tank') || stepInPath('cover')) && !stepIsCurrent('set')">
                                aktueller&nbsp;Preis:
                                <br />
                                <strong v-if="(stepInPath('tank') || stepInPath('cover')) && !stepIsCurrent('set')">{{ this.getSum() | currency }}</strong>
                                <strong v-if="stepIsCurrent('set')">{{ this.getTotal() | currency }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- VISUAL END -->

                <div class="configurator__column configurator__column--input column">

                    <div v-if="stepIsCurrent('loading')" class="configurator__pane configurator__pane--1">
                    </div>

                    <!-- FORM START -->
                    <div v-if="stepIsCurrent('calc')" class="configurator__pane configurator__pane--1">
                        <h3 class="configurator__headline title">
                            <span>01</span> Deine Projektsituation
                        </h3>
                        <form @touch="checkForm" method="post">
                            <div class="configurator__pad">
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <label class="label">Dachfläche</label>
                                        <p class="help">Bebaute Grundfläche</p>
                                    </div>
                                    <div class="field-body">
                                        <b-numberinput
                                            step="10"
                                            min="20"
                                            v-model="userinput.roofsize"
                                            expanded
                                            controls-position="compact"
                                        ></b-numberinput>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label">
                                        <label class="label">Dachart</label>
                                        <p class="help">für den Dachbeiwert</p>
                                    </div>
                                    <div class="field-body">
                                        <b-field>
                                            <b-select
                                                placeholder="bitte wählen"
                                                required
                                                expanded
                                                validation-message="Bitte wähle eine Dachart!"
                                                v-model="userinput.rooftype"
                                            >
                                                <option value="0.900001">Ton/glasiert</option>
                                                <option value="0.800001">Schiefer</option>
                                                <option value="0.800002">Beton</option>
                                                <option value="0.900002">Blech</option>
                                                <option value="0.7">Kiesschüttung</option>
                                                <option value="0.900003">Bitumen</option>
                                                <option value="0.800003">andere Dachmaterialien</option>
                                            </b-select>
                                        </b-field>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <label class="label">Gartenfläche</label>
                                        <p class="help">zu bewässernde Fläche</p>
                                    </div>
                                    <div class="field-body">
                                        <b-numberinput
                                            step="100"
                                            v-model="userinput.plotsize"
                                            expanded
                                            controls-position="compact"
                                        ></b-numberinput>
                                    </div>
                                </div>

                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <label class="label">PLZ</label>
                                        <p class="help">für den Ø Niederschlag</p>
                                    </div>
                                    <div class="field-body">
                                        <b-field>
                                            <b-input
                                                placeholder="Postleitzahl"
                                                required
                                                type="number"
                                                min="1000"
                                                v-model="userinput.zip"
                                                max="99999"
                                                expanded
                                                validation-message="Bitte gültige PLZ eingeben."
                                            ></b-input>
                                        </b-field>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- FORM END -->

                    <!-- TANK SELECTION -->
                    <div v-if="stepIsCurrent('tank')" class="configurator__pane configurator__pane--2">
                        <h3 class="configurator__headline title">
                            <span>02</span> Die Tankempfehlung
                        </h3>

                        <template v-if="mode == 'rain' || mode == 'rain-nocalc'">
                        <tooltip
                            v-for="tip in currentTips"
                            v-bind:tip="tip"
                            v-bind:key="tip.id"
                            v-on:show-info="showInfoModal"
                        ></tooltip>                        
                        </template>


                        <template v-if="relevantTanks.length === 1">
                        <div class="configurator__listitem configurator__listitem--active box">
                            <article class="media">
                                <div class="media-left">
                                    <figure v-if="assembly.tank.images != undefined">
                                        <img
                                            class="image is-64x64"
                                            v-bind:src="assembly.tank.images.layer"
                                            v-bind:alt="assembly.tank.name"
                                        />
                                    </figure>
                                    <figcaption
                                        class="configurator__listprice"
                                    >{{ assembly.tank.price | currency }}</figcaption>
                                </div>
                                <div class="media-content">
                                    <div class="configurator__productheadline">
                                        {{ assembly.tank.name }}
                                        <small>({{ assembly.tank.capacity }}l)</small>
                                    </div>
                                    {{ assembly.tank.desc }}
                                </div>
                            </article>
                        </div>
                        </template>


                        <template v-else>
                            <div
                                v-for="product in relevantTanks"
                                v-bind:key="product.id"
                                class="configurator__listitem box"
                                @click="assembly.tank=product"
                                v-bind:class="{'configurator__listitem--active':product==assembly.tank}"
                            >
                                <article class="media">
                                    <div class="media-left">
                                        <figure v-if="getComponentImage(product,'closeup')">
                                            <img
                                                class="image is-64x64"
                                                v-bind:src="getComponentImage(product,'closeup')"
                                                v-bind:alt="product.name"
                                            />
                                        </figure>
                                        <figcaption
                                            class="configurator__listprice"
                                        >{{ product.price | currency }}</figcaption>
                                    </div>
                                    <div class="media-content">
                                        <div class="configurator__productheadline">{{ product.name }}</div>
                                        {{ product.desc }}
                                        <a
                                            class="button configurator__productinfo"
                                            @click="showProductModal(product.id)"
                                        >
                                            <span class="icon is-medium">
                                                <i class="mdi mdi-24px mdi-information-variant"></i>
                                            </span>
                                        </a>
                                    </div>
                                </article>
                            </div>
                        </template>


                        
                    </div>

                    <!-- COVER SELECTION -->
                    <div v-if="stepIsCurrent('cover')" class="configurator__pane configurator__pane--3">
                        <h3 class="configurator__headline title">
                            <span>0{{ stepNr+1 }}</span> Der passende Deckel
                        </h3>
                        <tooltip
                            v-for="tip in currentTips"
                            v-bind:tip="tip"
                            v-bind:key="tip.id"
                            v-on:show-info="showInfoModal"
                        ></tooltip>
                        <div
                            v-for="product in products.cover"
                            v-bind:key="product.id"
                            class="configurator__listitem box"
                            @click="assembly.cover=product"
                            v-bind:class="{'configurator__listitem--active':product==assembly.cover}"
                        >
                            <article class="media">
                                <div class="media-left">
                                    <figure v-if="getComponentImage(product,'closeup')">
                                        <img
                                            class="image is-64x64"
                                            v-bind:src="getComponentImage(product,'closeup')"
                                            v-bind:alt="product.name"
                                        />
                                    </figure>
                                    <figcaption
                                        class="configurator__listprice"
                                    >{{ product.price | currency }}</figcaption>
                                </div>
                                <div class="media-content">
                                    <div class="configurator__productheadline">{{ product.name }}</div>
                                    {{ product.desc }}
                                    <a
                                        class="button configurator__productinfo"
                                        @click="showProductModal(product.id)"
                                    >
                                        <span class="icon is-medium">
                                            <i class="mdi mdi-24px mdi-information-variant"></i>
                                        </span>
                                    </a>
                                </div>
                            </article>
                        </div>

                        <div
                            class="configurator__listitem configurator__listitem--skip box"
                            @click="assembly.cover=null"
                        >
                            <article class="media columns is-vcentered">
                                <div class="media-left">
                                    <figure class="strikethrough">
                                        <img
                                            class="image is-32x32"
                                            src="/modules/custom/wn_conf/assets/img/icon-lid.svg"
                                            alt="kein Deckel"
                                        />
                                    </figure>
                                </div>
                                <div class="media-content">Ich benötige keinen Deckel</div>
                            </article>
                        </div>
                    </div>

                    <!-- FILTER SELECTION -->
                    <div v-if="stepIsCurrent('filter')" class="configurator__pane configurator__pane--4">
                        <h3 class="configurator__headline title">
                            <span>0{{ stepNr+1 }}</span> Der passende Filter
                        </h3>

                        <tooltip
                            v-for="tip in currentTips"
                            v-bind:tip="tip"
                            v-bind:key="tip.id"
                            v-on:show-info="showInfoModal"
                        ></tooltip>

                        <div
                            v-for="product in products.filter"
                            v-bind:key="product.id"
                            class="configurator__listitem box"
                            @click="assembly.filter=product"
                            v-bind:class="{'configurator__listitem--active':product==assembly.filter}"
                        >
                            <article class="media">
                                <div class="media-left">
                                    <figure v-if="getComponentImage(product,'closeup')">
                                        <img
                                            class="image is-64x64"
                                            v-bind:src="getComponentImage(product,'closeup')"
                                            v-bind:alt="product.name"
                                        />
                                    </figure>
                                    <figcaption
                                        class="configurator__listprice"
                                    >{{ product.price | currency }}</figcaption>
                                </div>
                                <div class="media-content">
                                    <div class="configurator__productheadline">{{ product.name }}</div>
                                    {{ product.desc }}
                                    <a
                                        class="button configurator__productinfo"
                                        @click="showProductModal(product.id)"
                                    >
                                        <span class="icon is-medium">
                                            <i class="mdi mdi-24px mdi-information-variant"></i>
                                        </span>
                                    </a>
                                </div>
                            </article>
                        </div>

                        <div
                            class="configurator__listitem configurator__listitem--skip box"
                            @click="assembly.filter=null"
                        >
                            <article class="media columns is-vcentered">
                                <div class="media-left">
                                    <figure class="strikethrough">
                                        <img
                                            class="image is-32x32"
                                            src="/modules/custom/wn_conf/assets/img/icon-filter.svg"
                                            alt="kein Filter"
                                        />
                                    </figure>
                                </div>
                                <div class="media-content">Ich benötige keinen Filter</div>
                            </article>
                        </div>
                    </div>

                    <!-- EXTRACTION SELECTION -->    
                    <div v-if="stepIsCurrent('extraction')"  class="configurator__pane configurator__pane--5">
                        <h3 class="configurator__headline title">
                            <span>0{{ stepNr+1 }}</span> Die passende Pumpe
                        </h3>

                        <tooltip
                            v-for="tip in currentTips"
                            v-bind:tip="tip"
                            v-bind:key="tip.id"
                            v-on:show-info="showInfoModal"
                        ></tooltip>

                        <div
                            v-for="product in products.extraction"
                            v-bind:key="product.id"
                            class="configurator__listitem box"
                            @click="assembly.extraction=product"
                            v-bind:class="{'configurator__listitem--active':product==assembly.extraction}"
                        >
                            <article class="media">
                                <div class="media-left">
                                    <figure v-if="getComponentImage(product,'closeup')">
                                        <img
                                            class="image is-64x64"
                                            v-bind:src="getComponentImage(product,'closeup')"
                                            v-bind:alt="product.name"
                                        />
                                    </figure>
                                    <figcaption
                                        class="configurator__listprice"
                                    >{{ product.price | currency }}</figcaption>
                                </div>
                                <div class="media-content">
                                    <div class="configurator__productheadline">{{ product.name }}</div>
                                    {{ product.desc }}
                                    <a
                                        class="button configurator__productinfo"
                                        @click="showProductModal(product.id)"
                                    >
                                        <span class="icon is-medium">
                                            <i class="mdi mdi-24px mdi-information-variant"></i>
                                        </span>
                                    </a>
                                </div>
                            </article>
                        </div>

                        <div
                            class="configurator__listitem configurator__listitem--skip box"
                            @click="assembly.extraction=null"
                        >
                            <article class="media columns is-vcentered">
                                <div class="media-left">
                                    <figure class="strikethrough">
                                        <img
                                            class="image is-32x32"
                                            src="/modules/custom/wn_conf/assets/img/icon-pump.svg"
                                            alt="keine Pumpe"
                                        />
                                    </figure>
                                </div>
                                <div class="media-content">Ich benötige keine Pumpe</div>
                            </article>
                        </div>
                    </div>

                    <!-- SET  -->
                    <div v-if="stepIsCurrent('set')"  class="configurator__pane configurator__pane--6">
                        <h3 class="configurator__headline title">
                            <span>0{{ stepNr+1 }}</span> Dein Set
                        </h3>
                        <div class="configurator__pad">
                            <ul class="shoppinglist">
                                <template v-for="(product, name) in assembly">
                                    <template v-if="product != undefined && typeof(product) === 'object'">
                                        <li class="shoppinglist__item" v-bind:key="product.id">
                                            <template v-if="name != 'cover'">
                                                <div class="shoppinglist__left">
                                                    <span
                                                        class="shoppinglist__ammount has-text-primary"
                                                    >1x</span>
                                                </div>
                                                <div class="shoppinglist__middle">{{ product.name }}</div>
                                                <div class="shoppinglist__right">
                                                    <span
                                                        class="shoppinglist__price"
                                                    >{{ product.price | currency }}</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="shoppinglist__left">
                                                    <span
                                                        class="has-text-primary"
                                                    >{{ assembly.tank.item_count }}x</span>
                                                </div>
                                                <div class="shoppinglist__middle">{{ product.name }}</div>
                                                <div class="shoppinglist__right">
                                                    <span
                                                        class="shoppinglist__price"
                                                    >{{ assembly.tank.item_count * product.price | currency }}</span>
                                                </div>
                                            </template>
                                        </li>
                                    </template>
                                </template>
                                <li v-if="set" class="shoppinglist__item">
                                    <span class="has-text-primary">Set-Rabatt (5%)</span>
                                    <span class="shoppinglist__price has-text-primary">
                                        <strong>- {{ discount | currency }}</strong>
                                    </span>
                                </li>
                                <li class="shoppinglist__summ">
                                    <span>Gesamtsumme</span>
                                    <span class="shoppinglist__price">
                                        <strong>{{ total | currency }}</strong>
                                    </span>
                                </li>
                            </ul>
                            <div
                                class="shoppinglist__vatdisclaimer"
                            >Die Preise verstehen sich inklusive 20% MWSt und exklusive Versandkosten.</div>
                        </div>
                    </div>

                    <!-- NAVBAR - START -->
                    <nav v-if="!stepIsCurrent('loading')" class="columns is-gapless configurator__progress is-mobile">
                        <div
                            v-if="stepAvailable('calc')"
                            @click="backToStep('calc')"
                            v-bind:class="{ 'configurator__step--done': stepInPath('calc'), 'configurator__step--active': stepIsCurrent('calc') }"
                            class="configurator__step column has-text-centered"                           
                        >
                            <span class="icon">
                                <img src="/modules/custom/wn_conf/assets/img/icon-home.svg" alt />
                            </span>
                        </div>
                        <div
                            v-if="stepAvailable('tank')"
                            @click="backToStep('tank')"
                            v-bind:class="{ 'configurator__step--done': stepInPath('tank'), 'configurator__step--active': stepIsCurrent('tank') }"
                            class="configurator__step column has-text-centered"
                        >
                            <span class="icon">
                                <img src="/modules/custom/wn_conf/assets/img/icon-tank.svg" alt />
                            </span>
                        </div>

                        <div
                            v-if="stepAvailable('cover')"
                            @click="backToStep('cover')"
                            v-bind:class="{ 'configurator__step--done': stepInPath('cover'), 'configurator__step--active': stepIsCurrent('cover') }"
                            class="configurator__step column has-text-centered"
                        >
                            <span class="icon">
                                <img src="/modules/custom/wn_conf/assets/img/icon-lid.svg" alt />
                            </span>
                        </div>
                        
                        <div
                            v-if="stepAvailable('filter')"
                            @click="backToStep('filter')"
                            v-bind:class="{ 'configurator__step--done': stepInPath('filter'), 'configurator__step--active': stepIsCurrent('filter') }"
                            class="configurator__step column has-text-centered"
                        >
                            <span class="icon">
                                <img src="/modules/custom/wn_conf/assets/img/icon-filter.svg" alt />
                            </span>
                        </div>

                        <div
                            v-if="stepAvailable('extraction')"
                            @click="backToStep('extraction')"
                            v-bind:class="{ 'configurator__step--done': stepInPath('extraction'), 'configurator__step--active': stepIsCurrent('extraction') }"
                            class="configurator__step column has-text-centered"
                        >
                            <span class="icon">
                                <img src="/modules/custom/wn_conf/assets/img/icon-pump.svg" alt />
                            </span>
                        </div>

                        <div
                            @click="nextStep"
                            v-bind:class="{ 'configurator__step--done': stepIsCurrent('set'), 'configurator__step--proceed': proceed==true || stepIsCurrent('set')}"
                            class="configurator__step column has-text-centered"
                        >
                            <!--span class="icon"><img src="/modules/custom/wn_conf/assets/img/icon-finish.svg" alt=""></span-->
                            <i v-if="!stepIsCurrent('set')" class="mdi mdi-24px mdi-arrow-right-bold-outline"></i>
                            <i v-if="stepIsCurrent('set')" class="mdi mdi-24px mdi-cart-outline"></i>
                        </div>
                        
                    </nav>
                    <!-- NAVBAR - END -->

                </div>
            </div>

            <modal v-bind:modal="modal" ref="infoModal"></modal>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import underscore from "vue-underscore";
import Buefy from "buefy";
import Vue2Filters from "vue2-filters";
import axios from "axios";
import Cookies from "js-cookie";
import innerHeight from "ios-inner-height";
import {_} from 'vue-underscore';



Vue.use(underscore);
//import "buefy/dist/buefy.css";

import Tooltip from "./components/Tooltip.vue";
import Modal from "./components/Modal.vue";

Vue.config.productionTip = false;
Vue.config.devtools = true;

// 2DO : implement currency default bith build system
var Vue2FiltersConfig = {
    currency: {
        symbol: "€",
        decimalDigits: 2,
        thousandsSeparator: ".",
        decimalSeparator: ",",
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: true
    }
};
// 2DO : implement currency default bith build system

Vue.use(Buefy);
Vue.use(Vue2Filters, Vue2FiltersConfig);

// as seen on: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
window.addEventListener("resize", function() {
    let vh = innerHeight() * 0.01;
    //let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
});

//window.onresize(); // called to initially set the height.

export default {
    name: "Configurator",

    //render: h => h(Configurator),

    //el: '#configurator',

    /*
    components: {
        tooltip: window.httpVueLoader(
            "/modules/custom/wn_conf/js/components/Tooltip.vue"
        ),
        modal: window.httpVueLoader(
            "/modules/custom/wn_conf/js/components/Modal.vue"
        )
    }
    ,
    */

    components: {
        Tooltip,
        Modal
    },
    mixins: [Vue2Filters.mixin],
    data: function() {
        return {

            // not used yet
            mode: "rain",
            steps: {
                "rain": ["calc","tank","cover","filter","extraction","set"],
                "rain-nocalc": ["cover","filter","extraction","set"],
                "wastewater": ["tank","cover","set"]
            },
            // not used yet

            step: 1,
            current: "loading",
            capacityTolerance: 0.1, // +/- tolerance while calculating tank capacity
            appliedCapacityTolerance: undefined,
            //proceed: false,
            errors: [],
            config: {
                cart_path: "/wn-shop/conf-exit",
                info_path: "/wn-shop-view/info-content/",
                product_path: "/wn-shop-view/product-info/",
                discount_percentage: 5
            },
            tips: [
                {
                    id: 1,
                    step: "tank",
                    title: "So berechnen wir dein Tankvolumen!",
                    type: "info",
                    node: "24"
                },
                {
                    id: 2,
                    step: "tank",
                    title: "Infos zu gekoppelten Tanks!",
                    type: "additional",
                    node: "20",
                    condition: function(vueInstance){
                        return (vueInstance.assembly.tank != undefined && vueInstance.assembly.tank.item_count > 1) ? true: false
                        },
                
                },
                {
                    id: 3,
                    step: "cover",
                    title: "Welche Abdeckung ist die Richige?",
                    type: "info",
                    node: "19"
                },
                {
                    id: 4,
                    step: "filter",
                    title: "Was unterscheidet die verschiedenen Filter?",
                    type: "info",
                    node: "18"
                },
                {
                    id: 5,
                    step: "extraction",
                    title: "Die Pumpsysteme im Vergleich",
                    type: "info",
                    node: "17"
                },
                {
                    id: 6,
                    step: "tank",
                    title: "Infos zu den unterschiedlichen Tankformen",
                    type: "additional",
                    node: "666",
                    condition: function(vueInstance){
                        return (vueInstance.relevantTanks.length > 1) ? true: false
                        },                    
                },                

            ],
            modal: {
                visible: false,
                url: ""
            },
            userinput: {
                roofsize: 100,
                plotsize: 300,
                zip: undefined,
                rooftype: undefined
            },
            configResults: {
                precipitation: undefined,
                capacity: {
                    min: undefined,
                    optimum: undefined,
                    max: undefined
                }
            },

            relevantTanks :{

            },
            assembly: {
                calc: undefined,
                tank: undefined,
                cover: undefined,
                filter: undefined,
                extraction: undefined
            },
            products: undefined
        };
    },
    methods: {
        checkForm: function() {

            for (var input in this.userinput) {
                if (this.userinput[input] == undefined) {
                    this.assembly.calc = undefined;
                    return;
                }
            }

            if(this.userinput.plotsize <= 0 || this.userinput.plotsize <= 0){
                this.assembly.calc = undefined;
                return false;
            }

            if (this.userinput.zip < 1000 || this.userinput.zip > 99999) {
                this.precipitation = null;
                this.assembly.calc = undefined;
                return false;
            } 
            
            else {
                axios
                    .get(
                        location.origin +
                            "/wn-rainfall/get/postal-code/" +
                            this.userinput.zip
                    )
                    .then(response => {
                        if (response.data.rainfall > 0) {
                            this.precipitation = response.data.rainfall;
                            this.calculateCapacity(this.capacityTolerance);
                            //this.proceed = true;
                            this.assembly.calc = true;

                            if (this.relevantTanks.length < 1 ) {
                                    this.assembly.calc = undefined;
                                    return false;
                                }



                        } else {
                            this.precipitation = null;
                            this.assembly.calc = undefined;
                            //this.proceed = false;
                            return false;
                        }
                    });
            }
        },
        storeData: function() {
            let cookie = {};

            if (this.assembly.tank != undefined) {
                cookie.tank = this.assembly.tank.id;
            }

            if (this.assembly.cover != undefined) {
                cookie.cover = this.assembly.cover.id;
            }
            if (this.assembly.filter != undefined) {
                cookie.filter = this.assembly.filter.id;
            }
            if (this.assembly.extraction != undefined) {
                cookie.extraction = this.assembly.extraction.id;
            }

            if (this.getDiscount() > 0) {
                cookie.discount = this.getDiscount();
            }

            if (
                this.assembly.tank != undefined ||
                this.assembly.cover != undefined ||
                this.assembly.filter != undefined ||
                this.assembly.extraction != undefined
            ) {
                Cookies.set("wn-config-data", cookie);
            }
        },
        fetchData: function() {
            let cookieJSON = Cookies.getJSON("configurator-data");
            if (cookieJSON != undefined) {
                this.data = cookieJSON; // => { foo: 'bar' }
            } else {
                //console.log('no previous configuration found')
            }
        }
        ,

        stepInPath: function(key) {

            if(this.steps[this.mode].indexOf(key) != -1 && this.steps[this.mode].indexOf(key) <= this.steps[this.mode].indexOf(this.current)) {
                return true;
            }
            else {
                return false;
            }
        }
        ,
    
        stepIsCurrent: function(key) {

            if(key === this.current) {
                return true;
            }
            else {
                return false;
            }
        }
        ,
            
        nextStep: function() {
            if (this.stepIsCurrent("set")) {
                this.storeData();
                window.location.pathname = this.config.cart_path;
            }
            else {
                this.current = this.steps[this.mode][this.stepNr+1]
            }           
        },
        addTank: function(index) {
            this.assembly.tank = this.products.tank[index];
        },
        backToStep: function(step) {
            if (this.stepInPath(step)) {
                this.current = step;
            }
        },

        calculateCapacity: function(capacityTolerance) {
            // https://wassernator.dev.eor.at/wn-rainfall/get/postal-code/1150

            var rainYield;
            var waterDemand;
            var capacity = {};

            this.assembly.tank = undefined;

            //var tankSizes = [2200,4200].sort();
            const tankSizes = Object.values(this.products.tank).map(
                //tank => parseInt(tank.capacity)
                function(tank) {
                    return parseInt(tank.capacity);
                }
            );
            const tanks = Object.values(this.products.tank);

            rainYield =
                parseFloat(this.userinput.roofsize) *
                parseFloat(this.userinput.rooftype) *
                parseFloat(this.precipitation);

            waterDemand = parseFloat(this.userinput.plotsize) * 100;

            capacity.optimum = Math.ceil((((rainYield + waterDemand) / 2) * 31) / 365);
            capacity.minimum = capacity.optimum * (1 - capacityTolerance)
            capacity.maximum = capacity.optimum * (1 + capacityTolerance)           
            this.configResults.capacity = capacity;

            var recommendedSize = tanks.reduce(function(prev, curr) {
                return Math.abs(curr.capacity - recommendedSize) <
                    Math.abs(prev.capacity - recommendedSize)
                    ? curr
                    : prev;
            });

            var relevantTanks = tanks.filter(tank => (tank.usage ==="rainwater" && tank.capacity >= capacity.minimum && tank.capacity <= capacity.maximum));

            this.appliedCapacityTolerance = capacityTolerance

            if(relevantTanks.length < 1 && this.appliedCapacityTolerance < 0.6) {
                //2DO : find Tanks when no tanks match :)
                
                return this.calculateCapacity(capacityTolerance + 0.1);
                
            }

            this.relevantTanks = relevantTanks;
            
            if(relevantTanks.length === 1) {
                this.addTank(relevantTanks[0].id);
            }
            
        }
        ,
        getWastewaterTanks: function() {
             return _.pick(this.products.tank,function(tank){ return tank.usage == "wastewater" })
        }
        ,
        
        getSum: function() {
            var sum = 0;
            for (var product in this.assembly) {
                
                // if the product is already in the assembly but the user navigated back to an earlier step -> don't count on total
                if(this.steps[this.mode].indexOf(product) > this.steps[this.mode].indexOf(this.current)){
                    continue;
                }
                
                if (
                    this.assembly[product] != undefined &&
                    typeof(this.assembly[product]) === "object" &&
                    this.assembly.hasOwnProperty(product)
                ) {
                    if (product == "cover") {
                        sum += parseFloat(
                            this.assembly["tank"]["item_count"] *
                                this.assembly[product]["price"]
                        );
                    } else {
                        sum += parseFloat(this.assembly[product]["price"]);
                    }
                }
            }
            return sum.toFixed(2);
        },

        getComponentImage: function(component, imageType) {

            // if we miss a valid component or there are no images return false
            if(component == undefined || component.images === undefined) {
                return false;
            }

            // if no specific imageType is requested select the image depending on the number of tanks
            if(imageType === undefined) {
                if(this.assembly.tank != undefined && this.assembly.tank.item_count == 1)
                    imageType = 'single'
                else if (this.assembly.tank != undefined && this.assembly.tank.item_count == 2){
                    imageType = 'double'
                }     
                else {
                    return false;
                }
            }

            // if it is a product without variants (tanks) just return the image
            if(component.images[imageType] !== undefined) {
                //console.log(component.images[imageType])
                return component.images[imageType];    
                }

            else {

                // try to find the fitting image for the tank design
                try {
                    if (component.images[this.assembly.tank.design][imageType] === (null || undefined)) {
                        throw new Error ("no fitting tank type image found");
                    }
                    //console.log(component.images[this.assembly.tank.design][imageType])
                    return component.images[this.assembly.tank.design][imageType];
                } catch (err) {

                    // try shere fallback
                    try {
                        if (component.images['sphere'][imageType] === (null || undefined)) {
                            throw new Error ("no sphere tank image found");
                        }
                        //console.log('sphere fallback: ' + component.images['sphere'][imageType]);
                        return component.images['sphere'][imageType];
                    } catch (err) {

                        // try single fallback
                        try {
                            if (component.images[this.assembly.tank.design]['single'] === (null || undefined)) {
                                throw new Error ("no single tank image found");
                            }
                            //console.log('single fallback: ' + component.images[this.assembly.tank.design]['single'])
                            return component.images[this.assembly.tank.design]['single']
                        } 
                        catch (err) {
                            console.log('no image to show')
                            return false;                            
                        }
                    }
                }
            }
        }
        ,
        isSet: function() {
            return this.assembly.tank != undefined &&
                this.assembly.cover != undefined &&
                this.assembly.filter != undefined &&
                this.assembly.extraction != undefined
                ? true
                : false;
        },
        getDiscount: function() {
            if (!this.isSet()) return 0;

            var discount =
                this.getSum() * (this.config.discount_percentage / 100);
            return discount.toFixed(2);
        },
        getTotal: function() {
            var total = this.getSum() - this.getDiscount();
            return total.toFixed(2);
        },
        showInfoModal: function(tip) {
            this.modal.url =
                this.config.info_path +
                tip.node +
                "/?type=" +
                encodeURI(tip.type);
            this.$refs.infoModal.show();
            //window.location.href = this.config.info_path + node;
        },
        showProductModal: function(node) {
            this.modal.url = this.config.product_path + node;
            this.$refs.infoModal.show();
            //window.location.href = this.config.info_path + node;
        }
        ,
        stepAvailable: function(step){
            return this.steps[this.mode].includes(step);
        }
    },
    computed: {

        proceed: function() {
            if( this.assembly[this.current] !== undefined )
                return true;
            else
                return false
        },

        stepNr: function() {
            return this.steps[this.mode].indexOf(this.current)
        },


        total: function() {
            return this.getTotal();
        },
        discount: function() {
            return this.getDiscount();
        },
        set: function() {
            return this.isSet();
        },
        sum: function() {
            if (this.stepIsCurrent('set')) return this.getTotal();
            else return this.getSum();
        },
        currentTips: function() {
            return this.tips.filter(
                function(tip) {
                    return tip.step == this.current;
                }.bind(this)
            );
        } 
    },
    watch: {
        userinput: {
            handler: "checkForm",
            deep: true
        }
    },
    //delimiters: ["<<", ">>"],

    created: function() {  
        axios
            //.get(location.origin + "/wn-shop/get/conf-products")
            //.get(location.origin + "/modules/custom/wn_conf/vue-conf/public/products-v3.json")
            .get(location.origin + "/wn-shop/get/conf-products/new")
            
            .then(response => {
                this.products = response.data.products;
                //console.dir(this.products);

                if(this.$route.params.tankId) {
                    this.addTank(this.$route.params.tankId);

                    if(this.products.tank[this.$route.params.tankId].usage  == 'rainwater') {
                        this.mode = 'rain-nocalc';
                        this.current = "cover";
                    }

                    if(this.products.tank[this.$route.params.tankId].usage  == 'wastewater') {
                        this.relevantTanks = this.getWastewaterTanks();
                        this.mode = 'wastewater';
                        this.current = "cover";
                    }
                    
                }
                else if(this.$route.params.mode == "wastewater") {
                    this.mode = 'wastewater';
                    this.current = "tank";
                    this.relevantTanks = this.getWastewaterTanks();
                }                
                else{
                    this.current = "calc";
                }

                return true;
            });
    },

    mounted: function() {        

    }
};
</script>

<style>
</style>